import styled from 'styled-components';

export const SlotsComp = styled.div`
  button.btn {
    margin: 1rem;
  }
`;
